import moment from 'moment';
import { IRouteNextTimelineEvent, IRouteLateEvent } from '../types/TRoute';
import { OrderCompletionStatus } from '../store/mst/models';

export enum TimelineViolationTypes {
  LATENESS = 'Lateness',
  EARLINESS = 'Earliness',
  TAG_MISMATCH = 'TagMismatch',
}

export const routeLateEvent = (routeNextTimelineEvent?: IRouteNextTimelineEvent): IRouteLateEvent | undefined => {
  if (!routeNextTimelineEvent?.originalArrivalTime) return undefined;

  const hasExpectedEta = !!(routeNextTimelineEvent.expectedArrivalTime
    && routeNextTimelineEvent.expectedArrivalTime !== routeNextTimelineEvent.originalArrivalTime);

  return {
    isRouteLate: hasExpectedEta,
    eventTime: routeNextTimelineEvent.originalArrivalTime,
    expectedTime: routeNextTimelineEvent.expectedArrivalTime || undefined,
    eventId: routeNextTimelineEvent.routeTimelineId,
    visitId: routeNextTimelineEvent.visitId,
  };
};

export const eventMinutesLate = (originalTime: string, expectedTime?: string): number => {
  if (!expectedTime) return 0;
  const original = moment.parseZone(originalTime).utc();
  const expected = moment.parseZone(expectedTime).utc();
  return expected.diff(original, 'minutes');
};

export const lateMessage = (status?: OrderCompletionStatus) => {
  switch (status) {
    case OrderCompletionStatus.DELIVERED:
      return 'This order was completed outside of its time window.';
    case OrderCompletionStatus.MISSED:
      return 'This order was skipped outside of its time window.';
    default:
      return 'This order is scheduled outside of its time window.';
  }
};
